<div class="posit-ion">
    <div class="img-bg-gr" style="padding: 20px;margin-bottom: 25px; cursor:text"
        *ngFor="let i of playerOrdersList">
        <div class="row" style="position: relative;">
            <div class="col-md-4 col-sm-4 col-xs-12">
                <div class="frt-rw">
                    <img style="border-radius: 10px;"
                        [src]="i?.restaurantData?.logo ? i?.restaurantData?.logo :  '../../../assets/image/Group 1261153964.svg'"
                        height="74" width="74">

                    <div style="padding: 0 0px 0 15px;
                    display: flex;" class="txt-rw">
                        <div class="chick" style="overflow-wrap: anywhere;">{{i?.restaurantData?.restaurantName}}</div>
                    </div>
                </div>

            </div>

            <div class="col-md-5 col-sm-5 col-xs-12 manageorderstime">
                <div class="event-data">
                    <div class="us-btt">{{i?.eventData?.eventTitle}}</div>
                    <div class="us-ftt">Order By: 
                        <span class="light-text">{{i?.userData?.firstName}} {{i?.userData?.lastName}}</span>
                      </div>
                      

                    <div class="d-flex justify-content-center">
                        <span class="d-flex align-items-center">
                            <img src="../../../assets/icon/Calendar.png" class="res-img" width="24"
                                height="24"><span class="june"
                                style="color:#888;">&nbsp;{{i?.eventData?.eventDate | date:'MMM dd, YYYY': 'UTC'}}</span>

                        </span>&nbsp;&nbsp;&nbsp;
                        <span class="dfle">
                            <img src="../../../assets/icon/TimeCircle.png" class="res-img" width="24"
                                height="24"><span class="time"
                                style="color:#888;">&nbsp;{{formatEventTime(i?.eventData?.eventDateTime)}}</span>

                        </span>
                    </div>
                </div>
            </div>

            <div class="col-md-3 col-sm-3 col-xs-12 pand-ing manageorderspending" style="padding-top: 10px;">
                <div class="pandding" *ngIf="i?.isDeclined==false">
                    {{i?.isAccepetd==false ? 'Pending':'Accepted'}} 
                </div>
                <div class="pandding" *ngIf="i?.isDeclined==true">
                    Declined
                </div>
            </div>
        </div>

        <span class="pendng viewinmobile">{{i?.isPaymentDone == true ? 'Paid': 'Pending'}}</span>

        <div style="margin-top: 26px;" class="mob-mt0">
            <div class="row align-items-center">
                <div class="col-md-8 col-sm-6 col-6 orderfirst">
                    <div class="order">
                        <div class="order-price">
                            Order Price
                        </div>
                        <div class="amout">
                            ${{convertToDecimal(i?.totalAmount)}} &nbsp;&nbsp;<span class="pendng hideinmobile">{{i?.isCancelled==true ? 'Canceled' :  i?.isPaymentDone==true ? 'Paid': 'Pending'}}</span>

                            <span style="margin-left: 3%;"
                                *ngIf="i?.isPaymentDone==true && (currentUser?.userDetails?.userType == 3 || this.currentUser.userType==3)"
                                class="favourite-icon">
                                <img src="../../../assets/icons/heart-filled.png" alt=""
                                    *ngIf="i?.isFavourite==true">
                                <img src="../../../assets/icons/heart-filled (1).png" alt=""
                                    *ngIf="i?.isFavourite==false">
                            </span>
                        </div>
                    </div>

                </div>

                <div class="col-md-4 col-sm-6 col-6 ordersecond" style="padding-top:10px; padding-right: 0px;">
                    <div class="d-flex justify-content-end">
                        <button class="view-dt-bt" (click)="viewDetails(i?._id)">
                            View Details
                        </button>
                    </div>

                </div>
            </div>
        </div>
    </div>
</div>